import * as React from 'react';
import {WithStyles, withStyles, Dialog, DialogTitle, DialogActions, MenuItem, Select, Box} from '@material-ui/core';
import { IEcoSplitSetting, IEcoSetting } from "@app-types/websocket/economy.types";
import { IFamilyMember } from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";
import Button from '@components/common/button/Button';
import {
    Col, StyledSlider, Row, StyledLabel,
    PercentageLabel, BoxedRow, CustomTextField, CustomDialogContent, CustomSelectInverted
} from './DialogComponens';
import { FamilyMemberType } from '@services/family/family.constants';
import { ecoContainerStyle } from './Container.style';
import { buttonContainedLarge } from 'src/main.style';
import { connect } from 'react-redux';

const tn = TranslateNew.getInstance();

interface IBalanceProps extends WithStyles<typeof ecoContainerStyle> {
    settingsOpen: boolean;
    family: IFamilyMember[];
    userId: number;

    split: IEcoSplitSetting[];
    currency: string;
    swishF1: string,
    swishF2: string,
    venmoF1: string,
    venmoF2: string,
    cashappF1: string,
    cashappF2: string,
    paypalF1: string;
    paypalF2: string;
    myPercentage:number,

    paymentMethod: "SWISH" | "VENMO" | "CASHAPP" | "PAYPAL",

    updateEcoSettings: (settings: IEcoSetting[]) => void;
    onClose: () => void;

}

interface IState {
    showHistory: boolean;

    currency: string;
    myPercentage: number;

    swishF1: string,
    swishF2: string,
    venmoF1: string,
    venmoF2: string,
    cashappF1: string,
    cashappF2: string,
    paypalF1: string;
    paypalF2: string;
    paymentMethod: "SWISH" | "VENMO" | "CASHAPP" | "PAYPAL",
}

class BalanceSettings extends React.Component<IBalanceProps, IState> {
    constructor(props: IBalanceProps) {
        super(props);

        this.state = {
            ...this.buildNewState(props),
        };

    }


    public componentDidUpdate(oldProps: IBalanceProps) {
        // The fallback split is rebuilt by mapStateToProps and can therefore get a
        // new identity on unrelated Redux updates. Do not reset a form while the
        // user is editing it; refresh it each time the dialog is opened instead.
        if (this.props.settingsOpen && !oldProps.settingsOpen) {
            this.setState(this.buildNewState(this.props));
        }
    }

    public buildNewState(props: IBalanceProps): IState {

        return ({
            showHistory: false,
            swishF1: props.swishF1 || "",
            swishF2: props.swishF2 || "",
            venmoF1: props.venmoF1 || "",
            venmoF2: props.venmoF2 || "",
            cashappF1: props.cashappF1 || "",
            cashappF2: props.cashappF2 || "",
            paypalF1: props.paypalF1 || "",
            paypalF2: props.paypalF2 || "",
            paymentMethod: props.paymentMethod,
            currency: props.currency,
            myPercentage: props.myPercentage,
        });

    }

    public render() {
        const { userId, onClose } = this.props;
        const coparent = this.props.family.find((mem) => mem.role === FamilyMemberType.PARENT && mem.id !== this.props.userId);
        const coparentName = coparent ? coparent.firstName : tn.lang.unknown;

        return (
            <Dialog
                open={this.props.settingsOpen}
                onClose={onClose}
            >
                <DialogTitle>
                    {tn.lang.ecoBalanceSettings}
                </DialogTitle>
                <CustomDialogContent>
                    <Box display="flex" justifyContent="space-around" alignItems="center">
                        <Select
                            value={this.state.paymentMethod}
                            onChange={(event) => this.setState({ paymentMethod: event.target.value as "SWISH" | "VENMO" | "CASHAPP" | "PAYPAL", })}
                            displayEmpty={true}
                            fullWidth={true}
                            disableUnderline={true}
                        >
                            <MenuItem value="">
                                <span style={{ padding: "8px" }}>{tn.lang.ecoBalancePaymentMethod}</span>
                            </MenuItem>
                            <MenuItem value="SWISH">
                                Swish
                            </MenuItem>
                            <MenuItem value="CASHAPP">
                                Cash App
                            </MenuItem>
                            <MenuItem value="VENMO">
                                Venmo
                            </MenuItem>
                            <MenuItem value="PAYPAL">
                                PayPal
                            </MenuItem>
                        </Select>
                    </Box>


                    {this.renderSwishFields()}
                    {this.renderCashAppFields()}
                    {this.renderVenmoField()}
                    {this.renderPayPalFields()}
                    <BoxedRow >
                        <Row style={{ alignItems: 'center', justifyContent: 'space-between', flex: 1 }}>
                            <StyledLabel htmlFor="curr">{tn.lang.ecoBalanceCurrency}:</StyledLabel>
                            <CustomSelectInverted
                                name="curr"
                                id="curr"
                                value={this.state.currency}
                                displayEmpty={true}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setState({ currency: (event.target.value) })}
                                disableUnderline={true}
                                data={[
                                    { value: "AUD", element: <>AUD</> }, { value: "CAD", element: <>CAD</> }, { value: "CHF", element: <>CHF</> },
                                    { value: "CZK", element: <>CZK</> }, { value: "DKK", element: <>DKK</> }, { value: "EUR", element: <>EUR</> },
                                    { value: "GBP", element: <>GBP</> }, { value: "HKD", element: <>HKD</> }, { value: "ILS", element: <>ILS</> },
                                    { value: "JPY", element: <>JPY</> }, { value: "KRW", element: <>KRW</> }, { value: "NOK", element: <>NOK</> },
                                    { value: "NZD", element: <>NZD</> }, { value: "PLN", element: <>PLN</> }, { value: "SEK", element: <>SEK</> },
                                    { value: "THB", element: <>THB</> }, { value: "TRY", element: <>TRY</> }, { value: "USD", element: <>USD</> },]}
                            />
                        </Row>
                    </BoxedRow>
                    <PercentageLabel>{tn.lang.ecoBalanceSplit}</PercentageLabel>


                    <Col>
                        <StyledSlider
                            name="split"
                            value={this.state.myPercentage}
                            onChange={(event: any, value: number | number[]) => { this.setState({ myPercentage: (value as number) }); }}
                            min={0}
                            max={100}
                            step={1}
                        />
                    </Col>
                    <Row style={{ justifyContent: 'space-around' }}>
                        <Col style={{ alignItems: 'center' }}>
                            <StyledLabel>{tn.lang.agreementCoparentPart(coparentName)}</StyledLabel>
                            <PercentageLabel>{100 - this.state.myPercentage} %</PercentageLabel>
                        </Col>
                        <Col style={{ alignItems: 'center' }}>
                            <StyledLabel>{tn.lang.agreementMyPartSet}</StyledLabel>
                            <PercentageLabel>{this.state.myPercentage} %</PercentageLabel>
                        </Col>
                    </Row>

                    {this.renderOldSettings(coparentName)}
                    {(this.props.split.length > 1) &&
                        <Button size="small" onClick={() => this.setState({ showHistory: !this.state.showHistory })}>
                            {tn.lang.ecoBalanceHistory}
                        </Button>}

                </CustomDialogContent>
                <DialogActions>
                    <Button style={buttonContainedLarge} variant='outlined' onClick={onClose}>  {tn.lang.cancel}</Button>
                    <Button style={buttonContainedLarge} onClick={() => this.updateSettings()}
                        disabled={!this.hasDoneSettingsChange()}
                        color='primary' variant='contained'>
                        {tn.lang.save}</Button>
                </DialogActions>

            </Dialog>
        );
    }

    private updateSettings() {
        const coparent = this.props.family.find((mem) => (mem.role === FamilyMemberType.PARENT && mem.id !== this.props.userId));

        if (coparent === undefined) {
            return;
        }

        const newSettings: IEcoSetting[] = [];
        for (const split of this.props.split) {
            newSettings.push({
                startTime: split.start,
                currency: this.state.currency,
                paymentMethod: this.state.paymentMethod,
                accountIdOne: split.split[0].accountId,
                accountIdTwo: split.split[1].accountId,
                percentageIdOne: split.split[0].percentage,
                percentageIdTwo: (100 - split.split[0].percentage),
                transferIdOne: split.split[0].accountId < split.split[1].accountId? this.props.swishF1:this.props.swishF2,
                transferIdTwo: split.split[0].accountId < split.split[1].accountId? this.props.swishF2:this.props.swishF1,
                cashappOne: split.split[0].accountId < split.split[1].accountId? this.props.cashappF1:this.props.cashappF2,
                cashappTwo: split.split[0].accountId < split.split[1].accountId? this.props.cashappF2:this.props.cashappF1,
                venmoOne: split.split[0].accountId < split.split[1].accountId? this.props.venmoF1:this.props.venmoF2,
                venmoTwo: split.split[0].accountId < split.split[1].accountId? this.props.venmoF2:this.props.venmoF1,
                paypalOne: split.split[0].accountId < split.split[1].accountId? this.props.paypalF1:this.props.paypalF2,
                paypalTwo: split.split[0].accountId < split.split[1].accountId? this.props.paypalF2:this.props.paypalF1,
                
                
            });
        }

        newSettings.push({
            startTime: (this.props.split.length === 0 ? 0 : Date.now()),
            currency: this.state.currency,
            paymentMethod: this.state.paymentMethod,
            accountIdOne: this.props.userId,
            accountIdTwo: coparent.id,
            percentageIdOne: this.state.myPercentage,
            percentageIdTwo: (100 - this.state.myPercentage),
            transferIdOne: this.props.userId < coparent.id? this.state.swishF1:this.state.swishF2,
            transferIdTwo: this.props.userId < coparent.id? this.state.swishF2:this.state.swishF1,
            cashappOne: this.props.userId < coparent.id? this.state.cashappF1:this.state.cashappF2,
            cashappTwo: this.props.userId < coparent.id? this.state.cashappF2:this.state.cashappF1,
            venmoOne: this.props.userId < coparent.id? this.state.venmoF1:this.state.venmoF2,
            venmoTwo: this.props.userId < coparent.id? this.state.venmoF2:this.state.venmoF1,
            paypalOne: this.props.userId < coparent.id? this.state.paypalF1:this.state.paypalF2,
            paypalTwo: this.props.userId < coparent.id? this.state.paypalF2:this.state.paypalF1,

        });

        this.props.updateEcoSettings(newSettings);
        
        console.log(JSON.stringify(newSettings));

        this.props.onClose();
    }

    private hasDoneSettingsChange(): boolean {
        if (this.state.cashappF1 !== this.props.cashappF1) {return true;}
        if (this.state.cashappF2 !== this.props.cashappF2) {return true;}
        if (this.state.swishF1 !== this.props.swishF1) {return true;}
        if (this.state.swishF2 !== this.props.swishF2) {return true;}
        if (this.state.venmoF1 !== this.props.venmoF1) {return true;}
        if (this.state.venmoF2 !== this.props.venmoF2) {return true;}
        if (this.state.paypalF1 !== this.props.paypalF1) {return true;}
        if (this.state.paypalF2 !== this.props.paypalF2) {return true;}
        if (this.state.currency !== this.props.currency) {return true;}
        if (this.state.myPercentage !== this.props.myPercentage) {return true;}
        if (this.state.paymentMethod !== this.props.paymentMethod) {return true;}
        return false;
    }


    private renderOldSettings(coparentName: string) {
        const oldData: JSX.Element[] = [];
        if (this.state.showHistory) {
            let index = this.props.split.length - 1;
            while (index >= 0) {
                const setting = this.props.split[index];
                const myShare = setting.split.find((set) => set.accountId === this.props.userId);
                if (myShare && index !== (this.props.split.length - 1)) {
                    oldData.push(<Row key={index + "r"} style={{ justifyContent: 'space-around' }}>
                        <Col style={{ alignItems: 'center' }}>
                            <StyledLabel>{tn.lang.agreementCoparentPart(coparentName)}</StyledLabel>
                            <PercentageLabel>{100 - myShare.percentage} %</PercentageLabel>
                        </Col>
                        <Col style={{ alignItems: 'center' }}>
                            <StyledLabel>{tn.lang.agreementMyPartSet}</StyledLabel>
                            <PercentageLabel>{myShare.percentage} %</PercentageLabel>
                        </Col>
                    </Row>);
                }
                if (index !== 0) { 
                    const date = new Date(setting.start);
                    oldData.push(<PercentageLabel key={index + "d"} style={{ borderTop: '1px solid rgb(155, 149, 149)', paddingTop: '8px' }}>
                        {`${tn.lang.before} ${tn.formatMonthDate(date) + " " + date.getFullYear()}`} 
                    </PercentageLabel>);
                }

                index -= 1;
            }
        }
        return oldData;
    }

    private renderSwishFields() {
        if (this.state.paymentMethod !== "SWISH") return null;
        const coparent = this.props.family.find((mem) => mem.role === FamilyMemberType.PARENT && mem.id !== this.props.userId);
        if (!coparent) return null;
        const F1accountId = coparent.id < this.props.userId? coparent.id:this.props.userId;
        const F2accountId = coparent.id < this.props.userId? this.props.userId:coparent.id;

        return (
            <>
                <CustomTextField
                    value={this.state.swishF1}
                    type="tel"
                    inputMode="tel"
                    label={`${tn.lang.labelPhone} ${tn.familyMemberName(F1accountId, this.props.family)}`}
                    onChange={({ target }) => this.setState({ swishF1: target.value })}
                    placeholder="0701234567"
                    fullWidth={true}
                    InputProps={{ disableUnderline: true }}
                />
                <CustomTextField
                    value={this.state.swishF2}
                    type="tel"
                    inputMode="tel"
                    label={`${tn.lang.labelPhone} ${tn.familyMemberName(F2accountId, this.props.family)}`}
                    onChange={({ target }) => this.setState({ swishF2: target.value })}
                    placeholder="0701234567"
                    fullWidth={true}
                    InputProps={{ disableUnderline: true }}
                />
            </>
        );
    }
    private renderCashAppFields() {  
        if (this.state.paymentMethod !== "CASHAPP") return null;
        const coparent = this.props.family.find((mem) => mem.role === FamilyMemberType.PARENT && mem.id !== this.props.userId);
        if (!coparent) return null;
        const F1accountId = coparent.id < this.props.userId? coparent.id:this.props.userId;
        const F2accountId = coparent.id < this.props.userId? this.props.userId:coparent.id;

        return (
            <>
                <CustomTextField
                    value={this.state.cashappF1}
                    label={`${tn.lang.ecoCashAppCashTagOne} ${tn.familyMemberName(F1accountId, this.props.family)}`}
                    onChange={({ target }) => this.setState({ cashappF1: target.value })}
                    placeholder={tn.lang.ecoCashAppCashTagOne}
                    fullWidth={true}
                    InputProps={{ disableUnderline: true }}
                />
                <CustomTextField
                    value={this.state.cashappF2}
                    label={`${tn.lang.ecoCashAppCashTagOne} ${tn.familyMemberName(F2accountId, this.props.family)}`}
                    onChange={({ target }) => this.setState({ cashappF2: target.value })}
                    placeholder={tn.lang.ecoCashAppCashTagOne}
                    fullWidth={true}
                    InputProps={{ disableUnderline: true }}
                />
            </>
        );
    }

    private renderVenmoField() {
        if (this.state.paymentMethod !== "VENMO") return null;
        const coparent = this.props.family.find((mem) => mem.role === FamilyMemberType.PARENT && mem.id !== this.props.userId);
        if (!coparent) return null;
        const F1accountId = coparent.id < this.props.userId? coparent.id:this.props.userId;
        const F2accountId = coparent.id < this.props.userId? this.props.userId:coparent.id;

        return (
            <>
                <CustomTextField
                    value={this.state.venmoF1}
                    label={`${tn.lang.ecoVenmoOne} ${tn.familyMemberName(F1accountId, this.props.family)}`}
                    onChange={({ target }) => this.setState({ venmoF1: target.value })}
                    placeholder={tn.lang.ecoVenmoPlaceholder}
                    fullWidth={true}
                    InputProps={{ disableUnderline: true }}
                />
                <CustomTextField
                    value={this.state.venmoF2}
                    label={`${tn.lang.ecoVenmoOne} ${tn.familyMemberName(F2accountId, this.props.family)}`}
                    onChange={({ target }) => this.setState({ venmoF2: target.value })}
                    placeholder={tn.lang.ecoVenmoPlaceholder}
                    fullWidth={true}
                    InputProps={{ disableUnderline: true }}
                />
            </>
        );
    }


    private renderPayPalFields() {
        if (this.state.paymentMethod !== "PAYPAL") return null;
        const coparent = this.props.family.find((mem) => mem.role === FamilyMemberType.PARENT && mem.id !== this.props.userId);
        if (!coparent) return null;
        const F1accountId = coparent.id < this.props.userId ? coparent.id : this.props.userId;
        const F2accountId = coparent.id < this.props.userId ? this.props.userId : coparent.id;
    
        return (
            <>
                <CustomTextField
                    value={this.state.paypalF1}
                    label={`${tn.lang.ecoPayPalName} ${tn.familyMemberName(F1accountId, this.props.family)}`}
                    onChange={({ target }) => this.setState({ paypalF1: target.value })}
                    placeholder={tn.lang.ecoPayPalName}
                    fullWidth={true}
                    InputProps={{ disableUnderline: true }}
                />
                <CustomTextField
                    value={this.state.paypalF2}
                    label={`${tn.lang.ecoPayPalName} ${tn.familyMemberName(F2accountId, this.props.family)}`}
                    onChange={({ target }) => this.setState({ paypalF2: target.value })}
                    placeholder={tn.lang.ecoPayPalName}
                    fullWidth={true}
                    InputProps={{ disableUnderline: true }}
                />
            </>
        );
    }
    
}


const mapStateToProps = (state: { family: {  family:IFamilyMember[] },
    user: { splitSetting:IEcoSplitSetting[], session: any, 
            currency:string,swishF1:string,swishF2:string,venmoF1:string,venmoF2:string,
            cashappF1:string, cashappF2:string,paypalF1: string, paypalF2: string, paymentMethod:"SWISH"|"VENMO"|"CASHAPP" |"PAYPAL",}; 
        }) => {

    let myPercentage = 50;



    const userId = state?.user?.session?.data?.id ?? 0;
    const family:IFamilyMember[] = Array.isArray(state?.family?.family) ? state.family.family : [];

    // Persisted state can hold null here, so only trust arrays.
    let split:IEcoSplitSetting[]|undefined = Array.isArray(state?.user?.splitSetting) ? state.user.splitSetting : undefined;

    if (split === undefined || split.length === 0) {
        split = [{start:0, split: family.filter((mem) => mem.role === FamilyMemberType.PARENT).map((mem) =>
            ({accountId:mem.id, percentage:50}))}]
    }


    let start = -1;
    for (const splitSetting of split) {
        if (!splitSetting || !Array.isArray(splitSetting.split)) {
            continue;
        }
        if (splitSetting.start > start) {
            start = splitSetting.start;
            if (splitSetting.split.length > 0 && splitSetting.split[0] && splitSetting.split[0].accountId === userId) {
                myPercentage = splitSetting.split[0].percentage;
            } else if (splitSetting.split.length > 1 && splitSetting.split[1] && splitSetting.split[1].accountId === userId) {
                myPercentage = splitSetting.split[1].percentage;
            }
        }
    }



    return {
        split,
        currency: state.user.currency || "SEK",
        swishF1: state.user.swishF1 || "",
        swishF2: state.user.swishF2 || "",
        venmoF1: state.user.venmoF1 || "",
        venmoF2: state.user.venmoF2 || "",
        cashappF1: state.user.cashappF1 || "",
        cashappF2: state.user.cashappF2 || "",
        paypalF1: state.user.paypalF1 || "",
        paypalF2: state.user.paypalF2 || "",
        paymentMethod: state.user.paymentMethod === "VENMO" ||
            state.user.paymentMethod === "CASHAPP" ||
            state.user.paymentMethod === "PAYPAL"
            ? state.user.paymentMethod
            : "SWISH",
        myPercentage,
    };
};





export default connect(mapStateToProps)(withStyles(ecoContainerStyle)(BalanceSettings));



// WEBPACK FOOTER //
// ./src/components/economy/BalanceSettings.tsx